import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
// import { ManageLibraryComponent } from 'src/app/admin/manage-library/manage-library.component';


@Component({
  selector: 'atw-block-chatbox-config',
  templateUrl: './block-chatbox-config.component.html',
  styleUrls: ['./block-chatbox-config.component.scss']
})
export class AtwBlockChatboxConfig implements OnInit {
  @Input() blockChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() position: any; // là dữ liệu position hoặc mobile_config từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;


  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
  };
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
  ];
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb, 
  ) {}

  ngOnInit(): void {

  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateBlock(this.blockChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {
        
      });
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateBlock(this.blockChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {
        
      });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if(event.width) {
      this.position['width'] = event.width;
      this.class['block-chatbox']['width'] = event.width + 'px';
    }
    if(event.height) {
      this.position['height'] = event.height;
      this.class['block-chatbox']['min-height'] = event.height + 'px';
    
    }
    this.updateClass()
    this.updatePosition()
  }
  //Hàm update position
  updatePosition() {   
    this.vhQueryAutoWeb
      .updateBlock(this.blockChoosing._id, {
        [this.device + '_position']: this.position,
      })
      .then((bool: any) => {        
      });
  }

}
